module.exports = __webpack_public_path__ + "assets/img/a7d3-cr.svg";